import type { DigSetup, PlayKind, PlayOffer } from '@goodtime/shared';
import { noBombs } from '../../logic/minigames/dig';
import { CupsDialog } from './CupsDialog';
import { DigDialog } from './DigDialog';
import { MatchDialog } from './MatchDialog';
import { PickDialog } from './PickDialog';
import { ScratchDialog } from './ScratchDialog';
import { SmashDialog } from './SmashDialog';
import { WheelDialog } from './WheelDialog';
import { WhackDialog } from './WhackDialog';
import type { MiniGameDeps, MiniGameScreen } from './types';

export interface MiniGameEntry {
  /** The TV title card before the game. */
  title: string;
  /** The line under the title card's title. */
  sub: string;
  /** The game's screen, built once per slot scene. */
  create(deps: MiniGameDeps): MiniGameScreen;
  /** A title card of its own for one offer (the treasure map's dig), or null. */
  titleFor?(offer: PlayOffer): { title: string; sub: string } | null;
}

/**
 * The road's mini-games drawn in Pixi, by `feature_plays.kind`. Hi-Lo has
 * its own dialog (HiLoDialog) and its own way in, so it isn't here.
 */
export const MINI_GAME_SCREENS: Partial<Record<PlayKind, MiniGameEntry>> = {
  pick: { title: 'PICK A PRIZE', sub: 'Every parcel holds a prize', create: (deps) => new PickDialog(deps) },
  smash: { title: 'SMASH THREE', sub: 'Hunt for the ×2', create: (deps) => new SmashDialog(deps) },
  match: { title: 'FIND THE PAIRS', sub: 'Remember where they are', create: (deps) => new MatchDialog(deps) },
  scratch: { title: 'SCRATCH CARD', sub: 'Find three the same', create: (deps) => new ScratchDialog(deps) },
  wheel: { title: 'LUCKY WHEEL', sub: 'Where will it stop?', create: (deps) => new WheelDialog(deps) },
  cups: { title: 'FIND THE COINS', sub: 'Keep your eye on the cup', create: (deps) => new CupsDialog(deps) },
  dig: {
    title: 'DIG FOR COINS',
    sub: 'Bank it before a bomb',
    create: (deps) => new DigDialog(deps),
    titleFor: (offer) => (noBombs(offer.setup as DigSetup | undefined) ? { title: 'DIG FOR TREASURE', sub: 'No bombs, just coins' } : null),
  },
  whack: { title: 'WHACK A MOLE', sub: 'Tap fast, win more', create: (deps) => new WhackDialog(deps) },
};
